import * as Yup from 'yup';

export interface ForgotPasswordForm {
  email: string;
}

export type ForgotPasswordFormShape = {
  [key in keyof ForgotPasswordForm]?: any;
};

export const schema = Yup.object().shape<ForgotPasswordFormShape>({
  email: Yup.string().required('Digite o email').email('Digite um email válido'),
});
